import React from 'react'
import Landing from './landing'
const IndexPage = () => <Landing />

export default IndexPage
